import React from 'react';
import { joinClassNames } from './joinClassNames.js';
const styles = {"button":"Button-module__button__T9ro8","primary":"Button-module__primary__dXv6K","secondary":"Button-module__secondary__gQ98-"};
const VARIANT_CLASS_NAMES = {
    primary: styles.primary,
    secondary: styles.secondary
};
/** A link that looks like a button, for an action that takes the person to another page. */
export function ButtonLink({ label, href, variant = 'primary' }) {
    return (React.createElement("a", { className: joinClassNames(styles.button, VARIANT_CLASS_NAMES[variant]), href: href }, label));
}
//# sourceMappingURL=ButtonLink.js.map